module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_hokkaido-442ad6f7efdef567f215b13082a1d5c2.jpg";